<script lang="ts" setup>
import { useField } from 'vee-validate'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: false,
    default: '',
  },
})

const slots = useSlots()

const trimErrorMessage = computed(() => {
  return errorMessage.value?.trim()
})

const { value, errorMessage } = useField<boolean>(() => props.name)
</script>
<template>
  <div class="form-checkbox">
    <div class="form-checkbox-option">
      <div class="flex items-center">
        <input
          v-model="value"
          type="checkbox"
          :name="props.name"
          class="form-checkbox-option__input"
        />
      </div>
      <p class="form-checkbox-option__description">
        <template v-if="slots.description">
          <slot name="description" />
        </template>
        <template v-else>
          {{ props.description }}
        </template>
      </p>
    </div>
    <span v-if="trimErrorMessage" class="form-checkbox-message">{{
      trimErrorMessage
    }}</span>
  </div>
</template>
